import { ITagScore } from '@/interfaces';
import { Grid, Paper, Typography } from '@mui/material';

const TopAccounts: React.FC<{
  interests: ITagScore[];
}> = ({ interests }) => (
  <Grid xs={12} spacing={2}>
    <Typography variant="h5" fontWeight={700} mb={2}>
      Top Accounts
    </Typography>
    <Grid container spacing={2}>
      {interests.map((interest) => (
        <Grid item xs={12} sm={4} md={4} key={interest.id}>
          <Paper
            sx={{
              padding: 2,
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <Typography variant="h6" fontWeight={700}>
              {interest.name}
            </Typography>
            <Grid spacing={1}>
              <Typography variant="body2">
                {interest.top_accounts?.map((brand) => brand).join(', ')}
              </Typography>
            </Grid>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Grid>
);

export default TopAccounts;
